// extracted by mini-css-extract-plugin
export var wrapper = "Join-module--wrapper---MNHx";
export var content = "Join-module--content--bFWa3";